import { atom, useRecoilState } from "recoil";
import {
  PointTabBar,
  PointTabColumn,
  PointTabContainer,
  PointTabText,
} from "../../Benefit/Point/PointTab";
import React from "react";
import styled from "styled-components";

export const N_matchMakingPartyTabState = atom<number>({
  key: "N_matchMakingPartyTabState",
  default: 0,
});

export default function N_MatchMakingPartyTab() {
  const [tab, setTab] = useRecoilState(N_matchMakingPartyTabState);

  return (
    <PointTabContainer>
      <PointTabColumn onClick={() => setTab(0)}>
        <PointTabText isActive={Boolean(tab === 0)}>파티 관리</PointTabText>

        <N_MatchMakingPartyTabBar tab={tab} />
      </PointTabColumn>

      <PointTabColumn onClick={() => setTab(1)}>
        <PointTabText isActive={Boolean(tab === 1)}>이메일 관리</PointTabText>
      </PointTabColumn>

      <PointTabColumn onClick={() => setTab(2)}>
        <PointTabText isActive={Boolean(tab === 2)}>Subs 관리</PointTabText>
      </PointTabColumn>
    </PointTabContainer>
  );
}

const N_MatchMakingPartyTabBar = styled(PointTabBar)`
  width: ${({ tab }) => (tab === 0 ? 70 : tab === 1 ? 85 : 85)}px;
  left: ${({ tab }) => (tab === 0 ? 0 : tab === 1 ? 85 : 185)}px;
`;
